import ServerDirections from "../config/server-directions";
import routeNames from "../router/route-names";
export class RequestService {
  getUserData(context) {
    return new Promise((resolve, reject) => {
      context.$http
        .get(ServerDirections.USER, {
          headers: {
            Authorization: `Bearer ${context.$store.getters.authToken}`,
          },
        })
        .then(
          (data) => {
            context.$store
              .dispatch("setUserData", {
                context,
                userData: data.body,
              })
              .then((userData) => {
                resolve(userData);
              });
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  getTransactions(context, offset, limit) {
    return new Promise((resolve, reject) => {
      context.$http
        .get(ServerDirections.USER_TRANSACTIONS, {
          headers: {
            Authorization: `Bearer ${context.$store.getters.authToken}`,
          },
          params: {
            limit: limit,
            offset: offset,
          },
        })
        .then(
          (data) => {
            context.$store
              .dispatch("setTransactions", {
                context,
                transactions: data.body.transactions,
              })
              .then((transactions) => {
                resolve(transactions);
              });
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  getCustomization(context) {
    return new Promise((resolve, reject) => {
      context.$http
        .get(
          ServerDirections.INSTANCE_ID.replace(
            "{id}",
            context.$store.getters.instanceId
          )
        )
        .then(
          (data) => {
            context.$store.dispatch("setCustomization", {
              context,
              customization: data.body,
            });
            resolve(data.body);
          },
          (error) => {
            if (error.status === 500) {
              context.$store.commit("setInstanceId", null);
              context.$router.push({ name: routeNames.NOT_FOUND });
            }
            context.error = error;
            reject(error);
          }
        );
    });
  }

  requestRefund(context) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(
          ServerDirections.REFUNDS,
          {},
          {
            headers: {
              Authorization: `Bearer ${context.$store.getters.authToken}`,
            },
          }
        )
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  getRefunds(context) {
    return new Promise((resolve, reject) => {
      context.$http
        .get(ServerDirections.REFUND, {
          headers: {
            Authorization: `Bearer ${context.$store.getters.authToken}`,
          },
        })
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            if (error.status === 404) {
              resolve(null);
            }
            context.error = error;
            reject(error);
          }
        );
    });
  }

  getCards(context) {
    return new Promise((resolve, reject) => {
      context.$http
        .get(ServerDirections.TOPUP_PAYLANDS_CARDS, {
          headers: {
            Authorization: `Bearer ${context.$store.getters.authToken}`,
          },
        })
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  rechargeWithCard(context, cardId, amount) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(
          ServerDirections.TOPUP_PAYLANDS_CARDS_ID.replace("{id}", cardId),
          {
            amount: amount,
          },
          {
            headers: {
              Authorization: `Bearer ${context.$store.getters.authToken}`,
            },
          }
        )
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  upgrade(context, categoryId, cardId) {
    const parameters = cardId ? { cardId: cardId } : {};
    return new Promise((resolve, reject) => {
      context.$http
        .post(
          ServerDirections.CATEGORY_UPGRADE,
          {
            category: categoryId,
            payment: {
              provider: "paylands",
              parameters: parameters,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${context.$store.getters.authToken}`,
            },
          }
        )
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  rechargePaylands(context, amount) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(
          ServerDirections.TOPUP_PAYLANDS,
          {
            amount: amount,
          },
          {
            headers: {
              Authorization: `Bearer ${context.$store.getters.authToken}`,
            },
          }
        )
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  rechargeMercadopago(context, amount) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(
          ServerDirections.TOPUP_MERCADOPAGO,
          {
            amount: amount,
          },
          {
            headers: {
              Authorization: `Bearer ${context.$store.getters.authToken}`,
            },
          }
        )
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }
  rechargeMit(context, amount) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(
          ServerDirections.TOPUP_MIT,
          {
            amount: amount,
          },
          {
            headers: {
              Authorization: `Bearer ${context.$store.getters.authToken}`,
            },
          }
        )
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  editUserData(context, userData) {
    return new Promise((resolve, reject) => {
      context.$http
        .put(ServerDirections.USER_UPDATE, userData, {
          headers: {
            Authorization: `Bearer ${context.$store.getters.authToken}`,
          },
        })
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }

  rechargePVS(context, amount) {
    return new Promise((resolve, reject) => {
      context.$http
        .post(
          ServerDirections.TOPUP_PVS,
          {amount: amount},
          {
            headers: {
              Authorization: `Bearer ${context.$store.getters.authToken}`,
            },
          }
        )
        .then(
          (data) => {
            resolve(data.body);
          },
          (error) => {
            context.error = error;
            reject(error);
          }
        );
    });
  }
}
